/* eslint-disable max-statements */
import { LeanClient } from 'types/client';
import { SurveyGroup } from '@zencity/survey-types';
import {
  DivisionTreeBySurveyType,
  RakeWeighterExecutionsBySurveyGroup,
} from 'screens/WidgetGenerator/reportGeneratorComponents/types';
import '../../../i18n';
import 'index.scss';

interface SurveysReportBuilderConfigState {
  surveysClient?: LeanClient;
  surveysGroups: SurveyGroup[];
  rakeWeighterExecutionsBySurveyGroup: RakeWeighterExecutionsBySurveyGroup;
  divisionTreeBySurveyType: DivisionTreeBySurveyType;
}

export const initialState: SurveysReportBuilderConfigState = {
  surveysGroups: [],
  rakeWeighterExecutionsBySurveyGroup: {},
  divisionTreeBySurveyType: {},
};

export const enum SurveysReportBuilderConfigActionsType {
  UPDATE_STATE = 'updateState',
  UPDATE_SELECTED_SURVEY_GROUP = 'updateSelectedSurveyGroup',
}

type SurveysReportBuilderConfigActions =
  | { type: SurveysReportBuilderConfigActionsType.UPDATE_STATE; payload: SurveysReportBuilderConfigState }
  | {
      type: SurveysReportBuilderConfigActionsType.UPDATE_SELECTED_SURVEY_GROUP;
      payload: SurveyGroup | undefined;
    };

export const reducer = (state: SurveysReportBuilderConfigState, action: SurveysReportBuilderConfigActions) => {
  switch (action.type) {
    case SurveysReportBuilderConfigActionsType.UPDATE_STATE:
      return action.payload;
    case SurveysReportBuilderConfigActionsType.UPDATE_SELECTED_SURVEY_GROUP:
      return { ...state, selectedSurveyGroup: action.payload };
    default:
      throw new Error('Unknown action', action);
  }
};
